module.exports = __webpack_public_path__ + "img/uk.7ff2e2c2.svg";